import type React from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { PhoneCollectionWrapper } from './components/PhoneCollectionWrapper';

async function loadPhoneCollectionStep(): Promise<typeof PhoneCollectionWrapper> {
	return (
		await import(
			/* webpackChunkName: "pages/start-a-petition-steps-phone-collection" */ './components/PhoneCollectionWrapper'
		)
	).PhoneCollectionWrapper;
}

export const PhoneCollectionLoader: React.FC = () => {
	return (
		<LazyComponent
			loadComponent={loadPhoneCollectionStep}
			fallback={
				<div className="m-auto">
					<Loader />
				</div>
			}
		/>
	);
};

export const preloadPhoneCollectionStep = loadPhoneCollectionStep;
